import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentBack = styled.div`
  padding: 1em;
  button {
    background: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
    font-size: 14px;
    font-weight: 500;
    border: none;
    box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
    border-radius: 5px;
    width: 4%;
    height: 25px;
    margin: 0px 8px 0 0;
    text-align: left;
    svg {
      font-size: 17px;
    }
  }
`;

export const ContentFilters = styled.div`
  display: none;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1em;
  margin: 2em 0px;
`;

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
`;

export const ContentDownloadFile = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const TextDownloadFile = styled.span`
  text-decoration: none;
  color: ${({ theme }) => theme.neutral.black};
  &:hover {
    text-decoration: underline;
  }
`;
